(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsFilterPicker', function () {
    return {
      templateUrl: "modules/common/directives/filter-picker/filter-picker.html"
    };
  });
})();
